import React, { useCallback } from 'react';
import { Col, CardBody, Card, Row } from 'reactstrap';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { Icons } from '../../../utils/Icons';
import { getInspectionListQuery } from '../../../slices/inspection/thunk';
import AddEditFiscalitation from './Add_Edit/AddEditFiscalitation';
import DeleteFiscalitation from './Delete/DeleteFiscalitation';
import IncumplimientosManagement from '../Incumplimientos/IncumplimientosManagement';
import FiscalizacionFilesModal from './Modals/FiscalizacionFilesModal';
import FiscalizacionDetailRow from './DetailPanels/FiscalizacionDetailRow';
import useFiscalizacionesList from './List/useFiscalizacionesList';
import useFiscalizacionColumns from './List/useFiscalizacionColumns';

const FiscalizacionesList = () => {
	const {
		dataFiscalizacion, modal, modalDelete, modalIncumplimientos, modalFiles,
		isEdit, refetchRemoteData, refetchActividades, isCentroRole,
		inspectionTypeListSelect, inspectionAuthorityListSelect,
		establishmentOptions, personOptions, managementPositionOptions, fiscalizerOptions,
		baseFilters, handleClearCacheAndRefetch,
		handleToggleModal, handleToggleModalDelete, handleToggleModalFiles,
		handleClickNew, handleClickEdit, handleClickDelete,
		handleClickIncumplimientos, handleClickFile,
		handleDeleteFiscalizacionSuccess, handleDataChange, handleSave,
		setModalIncumplimientos,
	} = useFiscalizacionesList();

	const { columns } = useFiscalizacionColumns({
		handleClickEdit, handleClickDelete, handleClickIncumplimientos,
		handleClickFile, isCentroRole,
	});

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getInspectionListQuery}
								baseFilters={baseFilters}
								queryPopulate={['establishment', 'responsible_person', 'role_user', 'inspection_type', 'inspection_authority', 'inspection_status']}
								remoteOperations={{ pagination: true, sorting: true, filtering: true }}
								customToolbarActions={[{ label: 'Crear', icon: Icons.plus, onClick: handleClickNew, title: 'Crear Fiscalización' }]}
								refetchRemoteData={refetchRemoteData}
								getRowIdTable={row => row._id}
								tableTitle='Lista de Fiscalizaciones'
								masterDetailComponent={useCallback(({ row }) => {
									if (!row.getIsExpanded()) return null;
									return (
										<FiscalizacionDetailRow
											row={row}
											externalRefetch={refetchActividades}
											onStatusChange={handleClearCacheAndRefetch}
										/>
									);
								}, [refetchActividades, handleClearCacheAndRefetch])}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditFiscalitation
				dataFiscalizacion={dataFiscalizacion}
				isOpen={modal}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				handleSave={handleSave}
				establishmentOptions={establishmentOptions}
				inspectionTypeOptions={inspectionTypeListSelect}
				inspectionAuthorityOptions={inspectionAuthorityListSelect}
				personOptions={personOptions}
				managementPositionOptions={managementPositionOptions}
				fiscalizerOptions={fiscalizerOptions}
			/>

			<DeleteFiscalitation
				dataFiscalizacion={dataFiscalizacion}
				isOpen={modalDelete}
				handleToggleModal={handleToggleModalDelete}
				onDeleteSuccess={handleDeleteFiscalizacionSuccess}
			/>

			<IncumplimientosManagement
				dataFiscalizacion={dataFiscalizacion}
				isOpen={modalIncumplimientos}
				handleToggleModal={() => setModalIncumplimientos(false)}
				onDataChange={handleDataChange}
			/>

			<FiscalizacionFilesModal
				dataFiscalizacion={dataFiscalizacion}
				isOpen={modalFiles}
				handleToggleModal={handleToggleModalFiles}
			/>
		</React.Fragment>
	);
};

export default FiscalizacionesList;
